import React, { Component } from "react";

// Components
import SetProfile from "./SetProfile";
import PersonalInfo from "./PersonalInfo";
import MedicalInfo from "./MedicalInfo";
import InsulinData from "./InsulinData";
import ScheduleDiet from "./ScheduleDiet";

// Assets
import ProfileIcon from "../../Assets/user.svg";

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Personal Information
      profileTitle:"Prathamesh Revan Vibhute",
      name: "Prathamesh Revan Vibhute",
      email: "prathuvibhute3110@gmail.com",
      password: "1234568",
      hiddenPassword: "",

      // Medical Parameters
      heightCnt: 10,
      weight: 10,
      bloodGroup: "AB",

      // Insulin List
      insulinIntake: [],

      // Diet Schedule State
      breakfastSchedule: {  
        hrs: 1,
        mins: 12,
      },
      lunchSchedule: {
        hrs: 1,
        mins: 12,
      },
      dinnerSchedule: {
        hrs: 1,
        mins: 12,
      },
    };
  }

  // On Input Change 
  onInputChange = (e,inputType) => {

    e.preventDefault();

    // Update User Name
    if (inputType === 1) {
      this.setState({ name: e.target.value });

      // Update Email
    } else if (inputType === 2) {
      this.setState({ email: e.target.value });

      // Update Password
    } else {
      this.setState({ password: e.target.value });
    }
  }

  // Password Hide
  onPasswordHide = (e) => {

    e.preventDefault();

    if (this.state.eyeClick) {
      let len = this.state.password.length;
      let pass = "";
      for (let i = 0; i <= len; i++) {
        pass = pass.concat("*");
      }

      this.setState({ hiddenPassword: pass, eyeClick: false });
    } else {
      this.setState({ eyeClick: true });
    }
  }

  // Input Submit
  onInputSubmitted(e) {
    this.setState({ profileTitle: this.state.profileTitle });
    e.preventDefault();
  }

  onTitleChange = (name) => {
    this.setState({ profileTitle: name});
  }

  // Hours Change
  changeHr = (hr,when) => {

    
    let mins = 0;
    if(when === 1) {
      console.log(hr,when)
      mins = this.state.breakfastSchedule.mins;
      this.setState({breakfastSchedule: {hrs: hr,mins: mins}})
    } else if(when === 2) {
      mins = this.state.lunchSchedule.mins;
      this.setState({lunchSchedule: {hrs: hr,mins: mins}})
    } else {
      mins = this.state.dinnerSchedule.mins;
      this.setState({dinnerSchedule: {hrs: hr,mins: mins}})
    }
  }

  // Minutes Change
  changeMin = (min,when) => {

    let hrs = 0;
    if(when === 1) {
      hrs = this.state.breakfastSchedule.hrs;
      this.setState({breakfastSchedule: {hrs: hrs,mins: min}})
    } else if(when === 2) {
      hrs = this.state.lunchSchedule.hrs;
      this.setState({lunchSchedule: {hrs: hrs,mins: min}})
    } else {
      hrs = this.state.dinnerSchedule.hrs;
      this.setState({dinnerSchedule: {hrs: hrs,mins: min}})
    }
  }

  // To Remove Insulin from  Insulin Selected List
  removeInsulin = (newData) => {
    let names = this.state.insulinIntake;

    this.setState({
      insulinIntake: names.filter((name) => {
        return name !== newData;
      }),
    });
  };

  // Add Insulin in Insulin Selected List
  addInsulin = (newData) => {
    let repeat = true;

    for (let i = 0; i <= this.state.insulinIntake.length; i++) {
      if (this.state.insulinIntake[i] === newData) {
        repeat = false;
        break;
      }
    }

    if (repeat)
      this.setState({ insulinIntake: [...this.state.insulinIntake, newData] });
  };

  render() {
    return (
      <div className="Profile">
        <div className="backBtn">
          <img src={ProfileIcon} alt="Setting" />
        </div>
        <div className="Profile_Holder">
          <SetProfile name={this.state.profileTitle}/>
          <PersonalInfo 
            name={this.state.name}
            email={this.state.email}
            password={this.state.password}
            onInputChange={this.onInputChange}
            onPasswordHide={this.onPasswordHide}
            onInputSubmitted={this.onInputSubmitted}
            onTitleChange={this.onTitleChange}
          />
          <div className="Profile_MiddleLine"></div>
          <MedicalInfo />
          <div className="Profile_MiddleLine"></div>
          <InsulinData
            insulinIntake={this.state.insulinIntake}
            addInsulin={this.addInsulin}
            removeInsulin={this.removeInsulin}
          />
          <div className="Profile_MiddleLine"></div>
          <ScheduleDiet
            dinnerSchedule={this.state.dinnerSchedule}
            breakfastSchedule={this.state.breakfastSchedule}
            lunchSchedule={this.state.lunchSchedule}
            changeHr={this.changeHr}
            changeMin={this.changeMin}
          />
          <div className="Profile_MiddleLine"></div>
        </div>
      </div>
    );
  }
}

export default Profile;
